import { useMutation } from '@apollo/client';
import { createOneCompanyActivityMutation } from './mutationt';
export function useCreateOneCompanyActivity() {
    return useMutation(createOneCompanyActivityMutation);
}
